import React, { Component } from 'react';

import './tabs.styles';

class Tab extends Component {
	render() {
		const {
			props: {
				valor, activeTab, label, onClick, icon,
			},
		} = this;

		let className = 'tab-list-item';

		if (valor === activeTab) {
			className += ' tab-current';
		}

		return (
			<li onClick={onClick} className={className}>
				{/* eslint-disable-next-line */}
				<a role="button" tabIndex="0" className={"icon icon-" + icon}>
					<span>{label}</span>
				</a>
			</li>
		);
	}
}

export default Tab;
